export default "__VITE_ASSET__mpFGSzBA__"